import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-pago-movil',
  templateUrl: './pago-movil.component.html',
  styleUrls: ['./pago-movil.component.scss'],
})
export class PagoMovilComponent implements OnInit {
  @Input() orderId: string;
  @Input() set amount(value: number) {
    if (value) {
      this._vAmount = value;
    }
  }

  @Output() finish$ = new EventEmitter();
  public formGroup: FormGroup;
  private _vAmount: number = 0;

  constructor(private _formBuilder: FormBuilder, private httpSv: HttpService) {}

  ngOnInit() {
    this.formGroup = this._formBuilder.group({
      phoneCode: ['58424'],
      phone: [''],
      dniType: ['V'],
      dni: [''],
    });
  }

  async sendData() {
    try {
      await this.httpSv.itemAction(
        {
          amount: this._vAmount,
          customerPhoneNumber: `${this.formGroup.value.phoneCode}${this.formGroup.value.phone}`,
          customerId: `${this.formGroup.value.dniType}${this.formGroup.value.dni}`,
        },
        'mercantil',
        'pass'
      );
    } catch (error) {
      throw new Error('Error al enviar los datos');
    }
  }
}
